import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";

import { LoadErrorCard, LoadingCard } from "@/components/load-state";
import { useAdminActivityActions, useAdminActivityAnalytics, useAdminUsers } from "@/lib/api";

import { SettingsSection } from "../settings-section";
import { ActivityDashboard } from "./activity-dashboard";
import { logbookPeriod } from "./utils";

/**
 * Settings → Activity log (admins): sign-ins and changes on this dashboard, and
 * who made them. The figures follow the log's time range (`logbookPeriod`).
 */
export function ActivitySettings() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const analyticsQuery = useAdminActivityAnalytics(logbookPeriod(params));
  const usersQuery = useAdminUsers();
  const actionsQuery = useAdminActivityActions();

  const isLoading = analyticsQuery.isLoading || usersQuery.isLoading || actionsQuery.isLoading;
  const isError = analyticsQuery.isError || usersQuery.isError || actionsQuery.isError;

  return (
    <SettingsSection title={t("nav.activity")}>
      {isLoading ? (
        <LoadingCard />
      ) : isError || !analyticsQuery.data ? (
        <LoadErrorCard
          message={t("activity.loadError")}
          onRetry={() => {
            void analyticsQuery.refetch();
            void usersQuery.refetch();
            void actionsQuery.refetch();
          }}
        />
      ) : (
        <ActivityDashboard
          analytics={analyticsQuery.data}
          updating={analyticsQuery.isPlaceholderData}
          users={usersQuery.data ?? []}
          actions={actionsQuery.data ?? []}
        />
      )}
    </SettingsSection>
  );
}
